module.exports = __webpack_public_path__ + "static/media/meal-period.cc71daf4.svg";